import { useExtraSmallScreen } from '@/hooks/useMediaQuery'
import { Story } from '@/interfaces/schema'
import Section from '@/layouts/section'
import getBgImgStyles from '@/lib/bg-image'

const StoryBanner = ({ image }: Pick<Story, 'image'>) => {
  const isExtraSmallScreen = useExtraSmallScreen()
  const imgHeight = isExtraSmallScreen ? 215 : 618

  const bg = getBgImgStyles({
    url: image?.url ?? '',
    height: imgHeight,
    width: '100%',
    parallax: false,
  })

  return (
    <Section
      styles={bg}
      className="relative rounded-sm w-full !max-w-[1360px] grid grid-cols-2 md:grid-cols-6 lg:grid-cols-12 gap-lg place-items-center"
    >
      <></>
    </Section>
  )
}

export default StoryBanner
